import type { Notification } from "@/contexts/notification-context"

import { isConnectivityError } from "./api"
import i18n from "./i18n"

const CONNECTIVITY_DESCRIPTION_KEY = "connectivity.description"

let notifyFn: ((config: Notification) => void) | null = null

export const registerNotificationFn = (
  fn: ((config: Notification) => void) | null
): void => {
  notifyFn = fn
}

export const getErrorNotificationKey = (
  error: unknown,
  domainFallbackKey: string
): string =>
  isConnectivityError(error) ? CONNECTIVITY_DESCRIPTION_KEY : domainFallbackKey

export const getErrorNotificationMessage = (
  error: unknown,
  domainFallback: string
): string =>
  isConnectivityError(error)
    ? i18n.t(CONNECTIVITY_DESCRIPTION_KEY, { ns: "common" })
    : domainFallback

export const showErrorNotification = (
  error: unknown,
  domainFallback?: string
): void => {
  notifyFn?.({
    message: getErrorNotificationMessage(
      error,
      domainFallback ?? i18n.t("mutation.defaultError", { ns: "common" })
    ),
    type: "error",
  })
}
